export default __webpack_public_path__ + "static/media/5.68482d70.svg";